import { formatNumber, parsePhoneNumberWithError, PhoneNumber } from 'libphonenumber-js'
import type { NumberFormat } from 'libphonenumber-js'

export default () => {
  const phone = (value: string, format: NumberFormat = 'NATIONAL'): string => {
    if (!value || value.length === 5) {
      return value
    }
    try {
      const parsed: PhoneNumber = parsePhoneNumberWithError(value)
      if (parsed.country !== 'US' && format === 'NATIONAL') {
        // Still format non-US numbers internationally
        return parsed.formatInternational()
      }
      return formatNumber(value, format)
    } catch {
      return value
    }
  }
  const phoneE164 = (value: string): string => {
    if (!value) { return value }
    try {
      const parsed = parsePhoneNumberWithError(value, 'US')
      return parsed.number
    } catch {
      return value
    }
  }
  const NON_DIALABLE_REGEX = /[*#]/g
  const NON_DIGIT_REGEX = /\D/g
  // Longer than the North American national plan and typed without a "+": the user
  // meant an international number, and parsing it against phoneE164's US default
  // region would silently relabel it as North American. Shorter values are returned
  // as typed so the number that is looked up is the number that is stored and dialled.
  const phoneDialable = (value: string): string => {
    if (!value) { return value }
    const cleaned = value.replace(NON_DIALABLE_REGEX, '')
    const digits = cleaned.replace(NON_DIGIT_REGEX, '')
    if (cleaned.startsWith('+') || digits.length <= 10) { return cleaned }
    return phoneE164(`+${cleaned}`)
  }
  // fixDirection: otherwise css "direction: rtl" would reverse the symbols order
  const fixDirection = (value: string): string => value ? value.split(' ').reverse().join(' ') : value
  const NO_LETTERS_AND_NUMBERS_REGEX = /[^a-zA-Z0-9]/g
  const onlyLettersAndNumbers = (value: string): string => !value ? value : value.replace(NO_LETTERS_AND_NUMBERS_REGEX, '').toLowerCase()
  const getSpeakerLabel = (speaker: string) => {
    if (speaker === '1' || speaker === '2') {
      return `Speaker ${speaker}`
    } else { return speaker }
  }
  return {
    phone,
    phoneE164,
    phoneDialable,
    fixDirection,
    onlyLettersAndNumbers,
    getSpeakerLabel
  }
}
